// eslint-disable-next-line max-len
var USER_INTERFACE_ARROW_04_RIGHT = 'M25.47,16a1.25,1.25,0,0,1-.42.94L8.63,31.68A1.26,1.26,0,1,1,7,29.8L22.32,16,7,2.2H7A1.26,1.26,0,0,1,8.63.32L25.05,15.06A1.25,1.25,0,0,1,25.47,16Z';

export { USER_INTERFACE_ARROW_04_RIGHT };
//# sourceMappingURL=USER_INTERFACE_ARROW_04_RIGHT.js.map
